import { render, staticRenderFns } from "./AssetsCatalog.vue?vue&type=template&id=79571840"
import script from "./AssetsCatalog.vue?vue&type=script&lang=js"
export * from "./AssetsCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports